export const OPENSOLAR_LOGO_URL_FULL = window.PUBLIC_URL + '/images/opensolar-logo-horizontal.svg'
export const OPENSOLAR_LOGO_URL_HALF = window.PUBLIC_URL + '/images/logo.svg'
